import NotFoundPage from '@/pages/not-found.page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$')({
  component: NotFoundPage,
});
